module.exports = __webpack_public_path__ + "img/PASL.9944e3f5.svg";